import React, { useState } from "react";
import { useTheme } from '~/ui/styled'
import { ColumnFlex, BetweenFlex, CenterFlex, Text, Button, GradientButton } from "~components/El"

const ChatGroupBotContentModal: React.FC<{
    onConfirm: (val: string | number) => void
    onClose: () => void
}> = ({ onConfirm, onClose }) => {
    const theme = useTheme()
    const [selected, setSelected] = useState("")
    return (
        <ColumnFlex
            width="100%"
            padding="20px"
            borderRadius="16px"
            bg={theme.colors.blockBackground}
        >
            <CenterFlex width="100%">
                <Text fontSize="16px" color={theme.colors.text} fontWeight={600}>请选择</Text>
            </CenterFlex>
            <BetweenFlex width="100%" mt="15px" gap="10px">
                <GradientButton
                    flex={1}
                    height="80px"
                    colors={['#fb994d', '#ee4b49']}
                    borderWidth="1px"
                    borderStyle="solid"
                    borderColor={selected === "dragon" ?  '#1ba54a' : 'transparent'}
                    onClick={() => {
                        setSelected('dragon')
                    }}
                >
                    <Text color={theme.colors.textLight} fontSize="36px" fontWeight="600">龙</Text>
                </GradientButton>

                <GradientButton
                    flex={1}
                    height="80px"
                    colors={['#74b0fa', '#4e98f3']}
                    borderWidth="1px"
                    borderStyle="solid"
                    borderColor={selected === "tiger" ?  '#1ba54a' : 'transparent'}
                    onClick={() => {
                        setSelected('tiger')
                    }}
                >
                    <Text color={theme.colors.textLight}  fontSize="36px" fontWeight="600">虎</Text>
                </GradientButton>
            </BetweenFlex>
            <BetweenFlex width="100%" mt="12px" gap="10px">
                <Button
                    flex="1"
                    height="44px"
                    borderRadius={theme.radii.lg}
                    bg={theme.colors.background}
                    onClick={onClose}
                >
                    <Text color={theme.colors.infoText} fontSize={16}>取消</Text>
                </Button>
                <Button
                    flex="1"
                    height="44px"
                    borderRadius={theme.radii.lg}
                    bg={theme.colors.primary}
                    disabled={!Boolean(selected)}
                    onClick={() => onConfirm(selected)}
                >
                    <Text color={theme.colors.textLight} fontSize={16}>确定</Text>
                </Button>
            </BetweenFlex>
        </ColumnFlex>
    )
}

export default ChatGroupBotContentModal
